import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class KatiAtikBeyanAPI extends BaseAPI {
    constructor() {
        const baseUrl =
            environment.API_URL + "KatiAtikBeyanlariListe";
        super(baseUrl);
    }

    getKatiAtikBeyanListe(sicilKodu:number, yili: number, aktifPasif: number, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        var request = new KatiAtikBeyanRequest(sicilKodu, yili, aktifPasif, ada, parsel, mahalleKodu, caddeSokakKodu);
        return this.post("", request, false);
    }
}
export default new KatiAtikBeyanAPI();
class KatiAtikBeyanRequest {

    public sicilKodu: number;
    public Yili: number;
    public AktifPasif: number;
    public ada?: number;
    public parsel?: number;
    public mahalleKodu?: number;
    public caddeSokakKodu?: number;

    constructor(sicilKodu: number, yili: number, aktifPasif: number, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        this.sicilKodu = sicilKodu;
        this.Yili = yili;
        this.AktifPasif = aktifPasif;
        this.ada = ada;
        this.parsel = parsel;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
    }
}
export { KatiAtikBeyanRequest };
